/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ObservableDoubleComponent from '../Utility/Component/Observable/ObservableDoubleComponent';
import ObservableIntComponent from '../Utility/Component/Observable/ObservableIntComponent';
import CLog, { LogTypes } from '../Utility/ComponentLogger';
import EffectSequence from './EffectSequence';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class UpdateableEffectSequence extends EffectSequence
{
    /** Whether this effect is dependent on an outside state. */
    @property({ override: true, visible: false })
    protected _effectDependent: boolean = false;

    /** Whether this effect is dependent on an outside state. */
    @property({ override: true, visible: false })
    protected isBlocking: boolean = false;

    @property()
    protected isDouble: boolean = false;

    private _observable: ObservableDoubleComponent = null;

    /** @hidden */
    protected start(): void
    {
        super.start();

        this.reference.SetContext(this.isDouble ? ObservableDoubleComponent : ObservableIntComponent);

        if (!this.reference.HasValue())
        {
            this.disableWithError('No Observable node found.', LogTypes.Initialization);
            return;
        }

        this._observable = this.reference.Value as ObservableDoubleComponent;

        if (!this.hasObservable())
        {
            this.disableWithError('No updateable label found.', LogTypes.Initialization);
            return;
        }

        let superTrigger: () => void = this.Trigger;
        this.Trigger = () => {
            if (this._observable.OldValue < 1) { return; }
            superTrigger();
        };

        this._observable.OnChanged(() => this.Trigger());
    }

    /** @hidden */
    protected onDestroy(): void
    {
        super.onDestroy();

        if (!this.hasObservable()) { return; }
        this._observable.OffChanged(() => this.Trigger());
    }

    private hasObservable(): boolean
    {
        return !!this._observable;
    }

    private disableWithError(message: string, type: LogTypes): void {
        this.enabled = false;
        CLog.error(message, this, type);
    }
}
